/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import './sharecontact.page.css'
import { useHistory } from 'react-router'
import {
	Icon,
	Box,
	HStack,
	VStack,
	Text,
	Image,
	Button,
	Switch,
	useDisclosure,
} from '@chakra-ui/react'
import defaultProfilePic from '../assets/images/profile.png'
import { useAuthContext } from '../context/auth.context'
import { loadAwsFile } from '../utils/aws.util'
import UserDetails from '../components/userdetails'
import { BiChevronUp } from 'react-icons/bi'
import { useOrganizationContext } from '../context/organization.context'
import { useLanguageContext } from '../context/locale.context'
import ButtonCTA from '../components/globalComponents/button'
import { useReactToPrint } from 'react-to-print'
import { useGetIdcardDetails } from '../hooks/asset.hooks'
import { QRcodeGlobal } from '../components/globalComponents/QRcode'
import SVGIcon from '../assets/svgIcons'
import { formatDateToAnotherFormat } from '../utils/date.utils'
import { EditQrCodeDetails } from '../components/shareBusinessCard/editQRCodeDetails'

const ShareContactPage = () => {
	const {
		state: { authData },
	} = useAuthContext()

	const {
		state: { orgsColor },
	} = useOrganizationContext()

	const {
		state: { locale },
	} = useLanguageContext()

	const { isOpen, onOpen, onClose } = useDisclosure()

	const { mutate: getIdcard, isLoading } = useGetIdcardDetails()
	const [profileImageData, setProfileImageData] = useState(null)
	const [orgLogo, setOrgLogo] = useState(null)
	const [showQRCode, setShowQRCode] = useState(true)
	const [idCardDetails, setIdCardDetails] = useState({})
	const [activityInlineData, setActivityInlineData] = useState({})

	const [details, setDetails] = useState({
		name: true,
		designation: true,
		company: true,
		phoneNumber: true,
		email: true,
		address: false,
		dateOfBirth: false,
		bloodGroup: false,
		altPhoneNumber: false,
		altEmail: false,
	})

	const {
		operating_asset_first_name,
		organization_name,
		asset_type_name,
		operating_asset_email_id,
		asset_phone_number,
		asset_phone_country_code,
		asset_date_of_birth,
		asset_blood_group,
		asset_address,
		asset_image_path,
		organization_image_path,
		organization_id,
		operating_asset_id,
	} = authData

	const {
		employee_first_name,
		employee_organization,
		employee_designation,
		employee_phone_number,
		employee_phone_country_code,
		employee_email_id,
		employee_blood_group,
		employee_home_city,
		employee_dob,
		employee_location,
		employee_alt_phone_num,
		employee_alt_email_id,
	} = activityInlineData

	// const getEmpDetails = () => {
	// 	let empDetails = {
	// 		employee_first_name,
	// 		employee_organization,
	// 	}
	// 	for (let keyy in details) {
	// 		if (details[keyy] && keyy !== 'name' && keyy !== 'company') {
	// 			if (keyy === 'designation') {
	// 				empDetails['asset_type_name'] = employee_designation
	// 			} else if (keyy === 'phoneNumber') {
	// 				empDetails['asset_phone_number'] = employee_phone_number
	// 				empDetails[
	// 					'asset_phone_country_code'
	// 				] = `+${employee_phone_country_code}`
	// 			} else if (keyy === 'email') {
	// 				empDetails['operating_asset_email_id'] = employee_email_id
	// 			} else if (keyy === 'address') {
	// 				empDetails['asset_address'] = employee_location
	// 			} else if (keyy === 'bloodGroup') {
	// 				empDetails['asset_blood_group'] = employee_blood_group
	// 			} else if (keyy === 'dateOfBirth') {
	// 				empDetails['asset_date_of_birth'] = employee_dob
	// 			}
	// 		}
	// 	}
	// 	return empDetails
	// }

	// const empDetails = getEmpDetails()
	const history = useHistory()

	useEffect(() => {
		setTimeout(() => {
			if (!!asset_image_path) {
				loadAwsFile(asset_image_path, d => {
					let data = 'data:' + d.type + ';base64,' + d.data
					setProfileImageData(data)
				})
			}
		}, 1000)
		setTimeout(() => {
			if (!!organization_image_path) {
				loadAwsFile(organization_image_path, d => {
					let data = 'data:' + d.type + ';base64,' + d.data
					setOrgLogo(data)
				})
			}
		}, 1000)
		loadIdCardDetails()
	}, [])

	const loadIdCardDetails = () => {
		if (!!operating_asset_id && !!organization_id) {
			getIdcard(
				{
					target_asset_id: operating_asset_id,
					organization_id: organization_id,
				},
				{
					onSuccess: async res => {
						if (res) {
							const {
								data: { status, response },
							} = res

							if (status === 200) {
								setIdCardDetails(response[0])
							}
						}
					},
				}
			)
		}
	}

	useEffect(() => {
		setTimeout(() => {
			if (!!asset_image_path) {
				loadAwsFile(asset_image_path, d => {
					let data = 'data:' + d.type + ';base64,' + d.data
					setProfileImageData(data)
				})
			}
		}, 1000)
	}, [asset_image_path, profileImageData])

	useEffect(() => {
		setTimeout(() => {
			if (!!organization_image_path) {
				loadAwsFile(organization_image_path, d => {
					let data = 'data:' + d.type + ';base64,' + d.data
					setOrgLogo(data)
				})
			}
		}, 1000)
	}, [organization_image_path, orgLogo])

	useEffect(() => {
		if (!!operating_asset_id && !!organization_id) {
			getIdcard(
				{
					target_asset_id: operating_asset_id,
					organization_id: organization_id,
				},
				{
					onSuccess: async res => {
						if (res) {
							const {
								data: { status, response },
							} = res

							if (status === 200) {
								setIdCardDetails(response[0])
							}
						}
					},
				}
			)
		}
	}, [operating_asset_id, organization_id])

	useEffect(() => {
		if (!!idCardDetails?.activity_inline_data) {
			setActivityInlineData(idCardDetails.activity_inline_data)
		}
	}, [idCardDetails])

	const contactDetail = () => {
		if (!!employee_first_name) {
			return `BEGIN:VCARD\nVERSION:3.0\nN:${employee_first_name}${
				details['company'] ? `\nORG:${organization_name}` : ''
			}${details['designation'] ? `\nTITLE:${asset_type_name}` : ''}${
				details['phoneNumber']
					? `\nTEL;PREF:+${employee_phone_country_code}${employee_phone_number}`
					: ''
			}${
				details['altPhoneNumber'] ? `\nTEL;PREF:+${employee_alt_phone_num}` : ''
			}${details['email'] ? `\nEMAIL:${employee_email_id}` : ''}${
				details['email'] ? `\nEMAIL:${employee_alt_email_id}` : ''
			}${
				details['address']
					? `\nADR:${!!employee_location ? employee_location : 'Not Available'}`
					: ''
			}${
				details['dateOfBirth']
					? !!employee_dob
						? `\nBDAY:${employee_dob.replaceAll('-', '')}`
						: ''
					: ''
			}${
				details['bloodGroup']
					? `\nNOTE:${
							!!employee_blood_group ? employee_blood_group : 'Not Available'
					  }`
					: ''
			}
			\nEND:VCARD`
		}
		return ''
	}
	console.log('contactDetail', contactDetail())

	const componentRef = useRef(null)
	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	})

	const qrCodeDetails = () => {
		return (
			<>
				<Box mt='5%' ml='30px'>
					<Box mr='4px' display='inline-block'>
						<SVGIcon
							iconName='GreenLogoLineSvg'
							svgProps={{
								width: '36',
								height: '10',
								viewBox: '0 0 36 10',
							}}
						/>
					</Box>{' '}
					{locale['Scan QR code']}
				</Box>

				<Box
					ref={componentRef}
					display='flex'
					flexDir='column'
					mb='5%'
					minH='400px'
					minW='400px'
					w='50%'
					gap='27px'
					alignItems='center'
					justifyContent='center'
					mx='auto'
					id='printSection'
				>
					<Box
						display='flex'
						w='350px'
						alignItems='center'
						justifyContent='center'
						bg='white'
						boxShadow='0px 2px 5px rgba(0, 0, 0, 0.1)'
						borderRadius='10px'
					>
						<VStack spacing={4} m='15px' w='100%'>
							<HStack w='100%' justifyContent='space-between'>
								<VStack spacing='0px' alignItems='flex-start'>
									<Box
										minW='134px'
										fontStyle='normal'
										fontWeight='900'
										fontSize='15px'
										letterSpacing='0.2px'
										color='#000000'
									>
										{employee_first_name}
									</Box>
									{details.designation ? (
										<Box
											minW='134px'
											fontStyle='normal'
											fontWeight='500'
											fontSize='11px'
											color='#000000'
											opacity='0.6'
										>
											{asset_type_name}
										</Box>
									) : null}
									{details.company ? (
										<Box
											minW='134px'
											fontStyle='normal'
											fontWeight='500'
											fontSize='11px'
											color='#000000'
											opacity='0.6'
										>
											{`@${organization_name}`}
										</Box>
									) : null}
								</VStack>
								<Box
									display='flex'
									justifyContent='center'
									alignItems='center'
									p='2px'
									w='48px'
									h='48px'
									borderRadius='5px'
									bg={orgsColor[organization_id]}
								>
									{!!orgLogo ? (
										<Image src={orgLogo} filter='brightness(0) invert(1)' />
									) : (
										<SVGIcon
											iconName='NavbarGreneLogoSvg'
											svgProps={{
												width: '38',
												height: '36',
												viewBox: '0 0 38 36',
											}}
										/>
									)}
								</Box>
							</HStack>

							<VStack spacing='0.5px' w='100%' alignItems='flex-start'>
								{details.phoneNumber ? (
									<HStack>
										<Box w='11px' h='11px' mr='7px'>
											<SVGIcon
												iconName='CallSvg'
												svgProps={{
													width: '11',
													height: '11',
													viewBox: '0 0 11 11',
												}}
												pathProps={{ fill: '#009B76' }}
											/>
										</Box>
										<Box
											w='270px'
											fontStyle='normal'
											fontWeight='400'
											fontSize='11px'
											letterSpacing='0.2px'
											color='#030303'
										>
											{!!asset_phone_number && !!asset_phone_country_code ? (
												`+${asset_phone_country_code} ${asset_phone_number}`
											) : (
												<Text color='#000000' opacity='0.8'>
													{locale['Not Available']}
												</Text>
											)}
										</Box>
									</HStack>
								) : null}
								{details.altPhoneNumber ? (
									<HStack>
										<Box w='11px' h='11px' mr='7px'>
											<SVGIcon
												iconName='CallSvg'
												svgProps={{
													width: '11',
													height: '11',
													viewBox: '0 0 11 11',
												}}
												pathProps={{ fill: '#009B76' }}
											/>
										</Box>
										<Box
											w='270px'
											fontStyle='normal'
											fontWeight='400'
											fontSize='11px'
											letterSpacing='0.2px'
											color='#030303'
										>
											{!!employee_alt_phone_num ? (
												`+${employee_alt_phone_num}`
											) : (
												<Text color='#000000' opacity='0.8'>
													{locale['Not Available']}
												</Text>
											)}
										</Box>
									</HStack>
								) : null}
								{details.email ? (
									<HStack>
										<Box w='11px' h='11px' mr='7px'>
											<SVGIcon
												iconName='MailSvg'
												svgProps={{
													width: '11',
													height: '11',
													viewBox: '0 0 11 11',
												}}
												pathProps={{ fill: '#009B76' }}
											/>
										</Box>
										<Box
											w='270px'
											fontStyle='normal'
											fontWeight='400'
											fontSize='11px'
											letterSpacing='0.2px'
											color='#030303'
										>
											{!!employee_email_id ? (
												employee_email_id
											) : (
												<Text color='#000000' opacity='0.8'>
													{locale['Not Available']}
												</Text>
											)}
										</Box>
									</HStack>
								) : null}
								{details.altEmail ? (
									<HStack>
										<Box w='11px' h='11px' mr='7px'>
											<SVGIcon
												iconName='MailSvg'
												svgProps={{
													width: '11',
													height: '11',
													viewBox: '0 0 11 11',
												}}
												pathProps={{ fill: '#009B76' }}
											/>
										</Box>
										<Box
											w='270px'
											fontStyle='normal'
											fontWeight='400'
											fontSize='11px'
											letterSpacing='0.2px'
											color='#030303'
										>
											{!!employee_alt_email_id ? (
												employee_alt_email_id
											) : (
												<Text color='#000000' opacity='0.8'>
													{locale['Not Available']}
												</Text>
											)}
										</Box>
									</HStack>
								) : null}
								{details.dateOfBirth ? (
									<HStack>
										<Box w='11px' h='11px' mr='7px'>
											<SVGIcon
												iconName='BdaySvg'
												svgProps={{
													width: '11',
													height: '11',
													viewBox: '0 0 11 11',
												}}
												pathProps={{ fill: '#009B76' }}
											/>
										</Box>
										<Box
											w='270px'
											fontStyle='normal'
											fontWeight='400'
											fontSize='11px'
											letterSpacing='0.2px'
											color='#030303'
										>
											{!!employee_dob ? (
												formatDateToAnotherFormat(
													employee_dob,
													'YYYY-MM-DD',
													'DD MMM YYYY'
												)
											) : (
												<Text color='#000000' opacity='0.8'>
													{locale['Not Available']}
												</Text>
											)}
										</Box>
									</HStack>
								) : null}
								{details.bloodGroup ? (
									<HStack>
										<Box w='11px' h='11px' mr='7px'>
											<SVGIcon
												iconName='BloodGroupSvg'
												svgProps={{
													width: '12',
													height: '12',
													viewBox: '0 0 12 12',
												}}
												pathProps={{ fill: '#009B76' }}
											/>
										</Box>
										<Box
											w='270px'
											fontStyle='normal'
											fontWeight='400'
											fontSize='11px'
											letterSpacing='0.2px'
											color='#030303'
										>
											{!!employee_blood_group ? (
												employee_blood_group
											) : (
												<Text color='#000000' opacity='0.8'>
													{locale['Not Available']}
												</Text>
											)}
										</Box>
									</HStack>
								) : null}
								{details.address ? (
									<HStack>
										<Box w='11px' h='11px' mr='7px'>
											<SVGIcon
												iconName='AddressSvg'
												svgProps={{
													width: '11',
													height: '11',
													viewBox: '0 0 11 11',
												}}
												pathProps={{ fill: '#009B76' }}
											/>
										</Box>
										<Box
											w='270px'
											fontStyle='normal'
											fontWeight='400'
											fontSize='11px'
											letterSpacing='0.2px'
											color='#030303'
										>
											{!!employee_location ? (
												employee_location
											) : (
												<Text color='#000000' opacity='0.8'>
													{locale['Not Available']}
												</Text>
											)}
										</Box>
									</HStack>
								) : null}
							</VStack>
						</VStack>
					</Box>

					<Box
						display='flex'
						w='350px'
						alignItems='center'
						justifyContent='center'
						bg='white'
						boxShadow='0px 2px 5px rgba(0, 0, 0, 0.1)'
						borderRadius='10px'
					>
						<Box
							w='100%'
							display='flex'
							alignItems='center'
							justifyContent='space-around'
							m='20px'
						>
							<QRcodeGlobal
								style={{
									minHeight: '120px',
									minWidth: '120px',
								}}
								level='Q'
								value={contactDetail()}
							/>
							<Box
								id='printButton'
								disply='flex'
								alignItems='center'
								justifyContent='center'
							>
								<ButtonCTA
									variant='idcardButton'
									maxW='100px'
									onClick={handlePrint}
								>
									<Box mr='10px'>
										<SVGIcon
											iconName='PrintSvg'
											svgProps={{
												width: '20',
												height: '20',
												viewBox: '0 0 20 20',
											}}
											pathProps={{ fill: '#009B76' }}
										/>
									</Box>
									Print
								</ButtonCTA>
							</Box>
						</Box>
					</Box>
				</Box>
			</>
		)
	}

	const navigateTo = () => {
		history.push('/idcard')
	}
	const shareContactContent = () => {
		return (
			<>
				<EditQrCodeDetails
					details={details}
					setDetails={setDetails}
					isOpen={isOpen}
					onClose={onClose}
				/>
				<Box
					display='flex'
					flexDir='column'
					h='100%'
					justifyContent='space-evenly'
					p='5px'
				>
					<Box
						display='flex'
						flexDir='row'
						justifyContent='flex-end'
						position='absolute'
						top='30px'
						right='40px'
					>
						<Box
							display='flex'
							alignItems='center'
							justifyContent='center'
							cursor='pointer'
							onClick={() => navigateTo()}
						>
							{locale['Share Contact']}
							<Icon as={BiChevronUp} color='brand.700' w={6} h={6} />{' '}
						</Box>
					</Box>
					{qrCodeDetails()}
					{/* {showQRCode ? (
						qrCodeDetails()
					) : (
						<EditQrCodeDetails
							details={details}
							setDetails={setDetails}
							isOpen={isOpen}
							onClose={onClose}
						/>
					)} */}
					<Box display='flex' justifyContent='flex-end' mr='60px'>
						<ButtonCTA
							variant='idcardButton'
							fontWeight='900'
							onClick={() => {
								// setShowQRCode(!showQRCode)
								onOpen()
							}}
						>
							{locale['EDIT QR CODE DETAILS']}
							{/* {showQRCode
								? locale['EDIT QR CODE DETAILS']
								: locale['GENERATE VCF QR CODE']} */}
						</ButtonCTA>
					</Box>
				</Box>
			</>
		)
	}

	return (
		<>
			<UserDetails
				idCardDetails={idCardDetails}
				profileImageData={profileImageData}
				defaultProfilePic={defaultProfilePic}
				orgLogo={orgLogo}
				orgColor={orgsColor[organization_id]}
				toBeDisplayed={shareContactContent()}
				loadIdCardDetails={loadIdCardDetails}
			/>
		</>
	)
}

export default ShareContactPage
